<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
        <a
          :color="color"
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{getTranslation(btnTerms, locale)}}
        </a>
      </template>
      <v-card>
        <v-card-title class="text-h5">
          {{getTranslation(titleTerms, locale)}}
        </v-card-title>
        <v-card-text>
          {{terms}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog = false"
          >
            {{ $t('common.cancel', locale) }}
          </v-btn>
          <v-btn
            :color="color"
            text
            @click="handleOK"
          >
            {{ $t('common.ok', locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import utils from '@/services/utils'
  export default {
    props: {
      terms: {
        type: String,
        default: null
      },
      onOK: {
        type: Function,
        required: true,
      },
      locale: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      dialog: false,
    }),
    computed: {
      titleTerms () {
        return { es: 'Términos y condiciones' }
      },
      btnTerms () {
        return { es: 'Aceptar términos y condiciones' }
      },
    },
    methods: {
      getTranslation (v, locale) {
        return utils.getTranslation(v, locale)
      },
      handleOK () {
        this.onOK()
        this.dialog = false
      },
    },
  }
</script>

